import { render, staticRenderFns } from "./my-cascader.vue?vue&type=template&id=54319f47&scoped=true&"
import script from "./my-cascader.vue?vue&type=script&lang=js&"
export * from "./my-cascader.vue?vue&type=script&lang=js&"
import style0 from "./my-cascader.vue?vue&type=style&index=0&id=54319f47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54319f47",
  null
  
)

export default component.exports